import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { performancemaster } from './../../models/admin';
import { UtilityService } from './../../services/utility.service';
import { AdminApiService } from './../../services/admin.service';
import { BMApiService } from './../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { delegatesHappinessMaster, surveyQuestionEntry, surveyOptionMaster } from './../../models/slakpi';
import { ToasterService } from '../../toaster.service';
@Component({
  selector: 'app-delegates-happiness-rate-master',
  templateUrl: './delegates-happiness-rate-master.component.html',
  styleUrls: ['./delegates-happiness-rate-master.component.css']
})
export class DelegatesHappinessRateMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('surveyquestionentrytemplate', { static: false }) surveyquestionentrytemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objDHM: any = new delegatesHappinessMaster();
  angularGrid: AngularGridInstance;
  performanceMasterData: object[];
  selected_itemUno: number = 0;
    pfmType: any;
    isTitle: boolean=false;
    continentDDList: any=[];
    isContinentDD: boolean=false;
    titleName: string;
    Title2: boolean;
  countryDDList: any;
    isCountryDD: boolean=false;
    isRegionDD: boolean=false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
    isSourceTypeDD: boolean=false;
    isSourceDesc: boolean=false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
    isBusinessModel: boolean=false;
  isTechnologyUsed: boolean = false;
  surveyQuestionID: any;
  isSubmitted: boolean;
  surveyName: any='';
  surveyOptionUno: any;
  
  startValue = [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }];
  imageValue = [{ value: "Image1" }, { value: "Image2" }, { value: "Image3" }, { value: "Image4" }, { value: "Image5" }, { value: "Image6" }, { value: "Image7" }, { value: "Image8" }, { value: "Image9" }, { value: "Image10" }]
  multipleSurveyQuestionEntry: any = [];
  surveyquestionbtn = 'Add';
  public selectedEditItemIndex: number;
  selectedEditItem: any = new surveyQuestionEntry();
  objSurveyOptionEntry: any = new surveyQuestionEntry();
  surveyOptionDDList: any = [];

  user: any = {};
  login_UserID: string;
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
    searchText: string;
    benchMarkYear_data: any[];
    currentYear: number;

  constructor(private formBuilder: FormBuilder, public restBMApi: BMApiService, private toaster: ToasterService, public restApi: AdminApiService, private route: ActivatedRoute, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.currentYear = Number(this.user.currentYear);
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    //if (this.user.role == 'BM Team')
    //  this.isBMTeam = true;

    if (!this.isAdmin && !this.isBMChambion)
      this.router.navigateByUrl('/access-denied');

  }

  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.getBenchMarkYear();
    this.loadDelegatesHappinessRateMaster();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }


  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.year.toString().toLowerCase() && a.year.toString().toLowerCase().includes(this.searchText.toLowerCase())||
        a.actual.toString().toLowerCase() && a.actual.toString().toLowerCase().includes(this.searchText.toLowerCase())||
        a.target.toString().toLowerCase() && a.target.toString().toLowerCase().includes(this.searchText.toLowerCase())
        );
    }
    else
      this.dataset = this.data;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'year', name: 'Year', field: 'year', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'actual', name: 'Actual', field: 'actual', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actual', 'actual'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'target', name: 'Target', field: 'target', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'target', 'target'),
          model: Filters.multipleSelect,

        }
      },
   
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            

            {
              command: 'entry-row', titleKey: 'Entry_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-plus-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';

                let rdata: any = args.dataContext;
                this.objDHM = rdata;
                
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              }
            },
            { divider: true, command: '', positionOrder: 63 },

           
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 66, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';

                    this.DeleteDelegatesHappinessRateMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }



  
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadDelegatesHappinessRateMaster() {
    this.spinner.show();
    let inpValue = new delegatesHappinessMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restBMApi.getDelegatesHappinessRateMaster(inpValue)
      .subscribe(data => {
        
       
        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              year: this.data[i].year,
              actual: this.data[i].actual,
              target: this.data[i].target
            };
          
          

        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
         
            this.setColnDefn();
         
        }
        else {
          
            this.setColnDefn();
          
        }
        this.performanceMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction = "add";
    this.objDHM = new delegatesHappinessMaster();
    
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-medium' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return
    }
    
    else {
      this.AddEditDelegatesHappinessRateMaster(this.objDHM)
    }
  }

  AddEditDelegatesHappinessRateMaster(data1: any) {
    
      let obj = new delegatesHappinessMaster();
    obj = data1;
    obj.itemUno = data1.id;
      obj.userUno = this.login_UserID;
      obj.condition = (this.pageAction == "add") ? 0 : 1;
      obj.tenantUno = 1;
     
    this.restBMApi.AddEditDelegatesHappinessRateMaster(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            //Swal.fire({
            //  type: 'success',
            //  title: 'Item saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'Item saved.');
            setTimeout(() => {
              this.pageAction = "add";
              this.objDHM = new delegatesHappinessMaster();
              this.spinner.hide();
              this.loadDelegatesHappinessRateMaster();
              this.modalRef.hide();
            }, 500);
           
          }
          else {
           //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    
    
  }
  DuplicateNameCheck(itemUno: number, nameEn: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.surveyTitle.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      

      });

      return rtnValue;
    }
  }


  DeleteDelegatesHappinessRateMaster(data1: any) {
    
    let obj = new delegatesHappinessMaster();
    obj.itemUno = data1.id;
    obj.userUno = this.login_UserID;
    obj.tenantUno = 1;
    this.restBMApi.deleteDelegatesHappinessRateMaster(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'Item deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadDelegatesHappinessRateMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objDHM = new delegatesHappinessMaster();
      this.pageAction = 'add'; }, 300);
  }
  onchangeDropDown(e) {
    this.isSubmitted = false;
  }
  onkeypress(e) {
    this.isSubmitted = false;
  }

  onAddSurveyQuestionEntry() {
    
    this.isSubmitted = true;
    if (this.multipleSurveyQuestionEntry.length <= 5) {

      let surveyOptionName = this.surveyOptionDDList.filter(a => a.id == this.surveyOptionUno)
      if (!this.checkAllValue()) {
        this.isSubmitted = false;
        if (this.surveyquestionbtn == 'Add') {
          let data1 = this.objSurveyOptionEntry;
          let objBenchmarkEntry = {
            sqUno: this.surveyQuestionID,
            surveyOptionUno: this.surveyOptionUno,
            surveyName: this.surveyName,
            surveyOptionName: surveyOptionName[0].optionTitle
          }
          
          //Check Duplicate Entry
          if (!this.CheckDuplicateItem(objBenchmarkEntry)) {
            this.multipleSurveyQuestionEntry.push(objBenchmarkEntry);
            this.clearEntryForm();
          }
          else {
            //Swal.fire('Error', 'Duplicate values not allowed.', 'error');
            this.toaster.show('error', 'Error', 'Duplicate values not allowed.');
            return;
          }

        }
        else {
          let data1 = this.objSurveyOptionEntry;
          let objSurveyOptionEntry = {
            sqUno: this.surveyQuestionID,
            surveyOptionUno: this.surveyOptionUno,
            surveyName: this.surveyName,
            surveyOptionName: surveyOptionName[0].optionTitle
          }

          
          //Check Duplicate Entry
          this.multipleSurveyQuestionEntry.splice(this.selectedEditItemIndex, 1);
          if (!this.CheckDuplicateItem(objSurveyOptionEntry)) {

            this.multipleSurveyQuestionEntry.push(objSurveyOptionEntry);
            this.objSurveyOptionEntry = new surveyQuestionEntry();
            this.surveyquestionbtn = 'Add';
            this.clearEntryForm();
          }
          else {
            let objSurveyOptionEntry = {


              sqUno: this.surveyQuestionID,

              surveyName: this.selectedEditItem.surveyName,
              surveyOptionUno: this.selectedEditItem.surveyOptionUno,
              surveyOptionName: surveyOptionName
            }

            this.multipleSurveyQuestionEntry.push(objSurveyOptionEntry);
            Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
          }
          //this.objTranBenchmarkKPI = new tranbenchmarkkpi();
        }
      }
    }
    else {
      Swal.fire('Error', 'only five entries allowed.', 'error'); return;
    }
    return false;
  }
  CheckDuplicateItem(obj: any) {
    if (this.multipleSurveyQuestionEntry != null && this.multipleSurveyQuestionEntry != undefined) {
      
      var rtnValue = false;
      let listItems = this.multipleSurveyQuestionEntry;

      let enteredItem = obj.surveyName.trim().toLowerCase();
      let enteredOptionUno = obj.surveyOptionUno;
      listItems.forEach((item) => {
        let existItem = item.surveyName.trim().toLowerCase();
        let existOptionUno = item.surveyOptionUno;
        if (enteredItem == existItem || existOptionUno == enteredItem ) {

          rtnValue = true;
        }

      });

      return rtnValue;
    }
  }
  checkAllValue() {
    let rtnValue = false;
    if ( this.surveyOptionUno == "" || this.surveyName == "") {
      rtnValue = true;
    }
    return rtnValue;
  }

  clearEntryForm() {

    this.surveyName = "";
    this.surveyOptionUno = "";
    this.surveyquestionbtn = 'Add';
  }

  onEditItem(idx) {
    
    this.selectedEditItem = this.multipleSurveyQuestionEntry[idx];
    this.surveyQuestionID = this.selectedEditItem.optionUno;
    this.surveyName = this.selectedEditItem.surveyName;
    this.surveyOptionUno = this.selectedEditItem.surveyOptionUno;


    this.selectedEditItemIndex = idx;
    this.surveyquestionbtn = 'Update';
    return false;
  }
  onRemoveItem(idx) {
    
    this.multipleSurveyQuestionEntry.splice(idx, 1);
    return false;
  }
  getSurveyOptionDD() {
    this.surveyOptionUno = '';
    let inpValue = new surveyOptionMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getSurveyOptionMaster(inpValue)
      .subscribe(data => {

        this.surveyOptionDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getSurveyQuestionEntry(id:any) {
    let inpValue = new surveyQuestionEntry();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getSurveyQuestionEntry(inpValue)
      .subscribe(data => {
       
        this.multipleSurveyQuestionEntry= data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }

  onSaveBenchMarkEntry() {
    if (this.multipleSurveyQuestionEntry.length > 0) {
      this.AddEditSurveyQuestionMultiEntry();
    }
    else {
     // Swal.fire('Error', 'Add alteast one entry and save', 'error');
      this.toaster.show('error', 'Error', 'Add alteast one entry and save.');
      return
    }
  }

  AddEditSurveyQuestionMultiEntry() {
    
    this.clearEntryForm();
    this.surveyquestionbtn = 'Add';
    let obj = new surveyQuestionEntry();

    obj.userUno = this.login_UserID;


    //XML Value For KPIBenchMark Entry

    let entryItems = this.multipleSurveyQuestionEntry;
    
    if (entryItems.length > 0) {
      obj.sqUno = this.surveyQuestionID;
      let strXmlValue = '<roots>';
      for (var i = 0; i < entryItems.length; i++) {

        strXmlValue += "<root>";
        strXmlValue += "<SurveyName>" + entryItems[i].surveyName + "</SurveyName>";
        strXmlValue += "<SurveyOptionUno>" + entryItems[i].surveyOptionUno + "</SurveyOptionUno>";
        strXmlValue += "<TenantUno>1</TenantUno>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      obj.xmlValue = strXmlValue;
    }
    else {
      obj.xmlValue = "";
    }


    this.modalRef.hide();
    
    this.restBMApi.addEditSurveyQuestionEntry(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
          this.spinner.hide();
        }
        else {
          this.modalRef.hide();
          //Swal.fire({
          //  type: 'success',
          //  title: 'Survey Question Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Survey Question Entry saved.');
          setTimeout(() => {
            this.spinner.hide();
            this.multipleSurveyQuestionEntry = [];
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.multipleSurveyQuestionEntry = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
  getBenchMarkYear() {
    
    let date = new Date();
   
    let StartYear = 2015;
    let EndYear = Number(this.currentYear) + 2;//date.getFullYear() + 2;
    let yearCount = EndYear - 2015;
    this.benchMarkYear_data = [];
    for (let i = 0; i < yearCount; i++) {
      this.benchMarkYear_data.push({ text: StartYear + i, value: StartYear + i });
    }

    this.benchMarkYear_data = this.benchMarkYear_data.reverse();
  }
   
}
